import { render } from "./UpdateIcon.vue?vue&type=template&id=6e35bec6&ts=true"
import script from "./UpdateIcon.vue?vue&type=script&lang=ts"
export * from "./UpdateIcon.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__